/**
 * @import { HTMLElementInfo } from 'spart/js/core.js'
 */
import store from 'util/store';
import openPage from 'spart/js/page.js';
import openChatPage from 'page/chat';
import { getPageHeader } from 'spart/js/component.js';
import { shareText } from 'spart/js/navigator.js';
import tl from 'spart/js/i18n.js';
import { updateElement } from 'spart/js/core.js';
import { _fetch, showProblemDetail } from 'spart/js/fetch.js';
import { registerPushNotification } from 'spart/js/notification.js';

function roomSelected(e) {
	registerPushNotification(false);
	const params = new URLSearchParams();
	params.set('r', e.currentTarget.dataset.id);
	openChatPage(params);
}

function getRoomUI(info) {
	const name = info.groupName + (info.roomName ? ': ' + info.roomName : '');

	const latest = !info.latestDateSent
		? { tag: 'i', text: '(no message)' }
		: !info.latestMessage
			? { tag: 'i', text: '(deleted message)' }
			: { text: info.latestMessage };

	const avatar = info.logo
		? { tag: 'img', class: 'avatar', alt: 'profile', src: info.logo }
		: {
			tag: 'div',
			class: 'avatar',
			content: [
				{ tag: 'i', class: 'bi bi-people-fill', style: 'font-size: 2em' },
			],
		};

	return [
		avatar,
		{
			tag: 'div',
			class: 'chat-room-info',
			content: [
				{
					tag: 'div',
					class: 'info-body',
					content: [
						{ tag: 'h5', class: 'room-name', html: name },
						{ tag: 'p', class: 'latest-message', content: [latest] },
					],
				},
			],
		},
	];
}

let page_content = null;

function setRooms(rooms) {
	if (rooms == null) {
		return fetchRooms();
	}

	/** @type {HTMLElementInfo[]} */
	let content;

	if (rooms.length == 0) {
		content = [
			{
				tag: 'div',
				class: 'chat-room',
				attri: { 'data-id': 1 },
				text: 'Visit anonymous group',
				events: { click: roomSelected },
			},
		];
		updateElement(page_content, { content });
		return;
	}

	content = rooms.map((x) => ({
		tag: 'div',
		class: 'chat-room',
		attri: { 'data-id': x.roomId },
		content: getRoomUI(x),
		events: { click: roomSelected },
	}));

	updateElement(page_content, { content });
}

async function fetchRooms() {
	const response = await _fetch('/api/rooms');

	if (!response.ok) {
		showProblemDetail(response);
		return []; // pretend an empty list
	}

	const data = await response.json();
	store.putRooms(data.rooms);
	await setRooms(data.rooms);
}

function shareLink() {
	const url = window.location.origin + '/chat';
	const text = tl(
		'DRIIMA is a distributed, reliable and intelligent instant messaging app.',
	);
	shareText(tl('Messaging App'), text, url);
}

async function openHomePage() {
	const page = openPage('home', { level: 1 });

	if (page.childElementCount) return; // if already set up, do not set up again

	page.addEventListener('page-resumed', fetchRooms);
	page.classList.add('flex-column');

	const menuOptions = [{ text: 'Share the app', events: { click: shareLink } }];

	const titleElem = { tag: 'span', html: 'DRIIMA' };
	const header = getPageHeader(false, titleElem, undefined, menuOptions);

	const content = {
		tag: 'div',
		class: 'page-content',
		callback: (elem) => (page_content = elem),
	};
	updateElement(page, { content: [header, content] });

	await store.getRooms().then(setRooms);
}

export default openHomePage;
